import React, { FC, useEffect, useState } from "react";
import { createGlobalStyle } from "styled-components";
import { motion } from "framer-motion";
import Container from "saur_ui_library/src/Atoms/Container/Container";
import Word from "saur_ui_library/src/Atoms/Word/Word";
import {  elevation } from "saur_ui_library/src/Theme";
import { ThemeType } from "saur_ui_library/src/BrandsConfig";
import { dateValues } from "../ecpHelper";

type Props = {
  onChange: any;
  title: any;
  className?: any;
  automatedTestId?: string;
  selectedValue?: any;
};

const MonthPicker: FC<Props> = ({
  onChange,
  title,
  className,
  selectedValue,
}) => {
  const [showList, setShowList] = useState(false);
  const [_selectedValue, setSelectedValue] = useState<any>(selectedValue);
  useEffect(()=>{
    if(selectedValue!== undefined){
      setSelectedValue(selectedValue);

    }
    else{
      setSelectedValue(dateValues[0]);

    }
  },[selectedValue])
  function handleOnChange(value: any) {
    setSelectedValue(value);
    onChange(value);
    setShowList(false);
  }
  function renderList() {
    return (
      showList && (
        <>
          <Container
            className="dropdown-overlay"
            onClick={() => setShowList(false)}
          />
          <motion.ul
            className="dropdown-list"
            initial={{ bottom: -40 }}
            animate={{ bottom: -10 }}
          >
            {dateValues.map((v) => {
              return (
                <li
                  className={`dropdown-list-item ${
                    _selectedValue && _selectedValue.id === v.id
                      ? "selected"
                      : ""
                  }`}
                  key={v.id}
                  onClick={() => handleOnChange(v)}
                  onKeyDown={() => handleOnChange(v)}
                  id={v.id}
                >
                  <Word
                    value={v.label}
                    textStyle="normalReg"
                    variant="span"
                    automatedTestId={v.id}
                  />
                </li>
              );
            })}
          </motion.ul>
        </>
      )
    );
  }
  return (
    <Container className="monthpicker sds-reset-style">
      <Styles />
      <Container className={`dropdown ${className}`}>
        <Word
          variant="p"
          className="season-begining"
          automatedTestId="season-begining"
          textStyle="normalReg"
          value={title}
        /><Container
        className={`dropdown-input ${_selectedValue ? 'selected' : ''}`}
        onClick={() => setShowList(true)}
      >
        <Word
          value={(_selectedValue && _selectedValue!==null) ? _selectedValue.showed : "Choisir un mois"}
          textStyle={_selectedValue ? 'normalReg' : 'normalItalic'}
          variant='span'
          automatedTestId={_selectedValue ? _selectedValue.automatedTestId : ''}
        />
       
      </Container>
      {renderList()}
      </Container>
    </Container>
  );
};
const Styles = createGlobalStyle`
    .monthpicker.sds-reset-style{
      margin-bottom: 15px;
      .season-begining{
      margin-top: 20px;
      }
      .dropdown {
      position: relative;
      .dropdown-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: ${elevation.base.default};
      }
      .dropdown-list {
        position: absolute;
        left: 0;
        right: 0;
        bottom: -10px;
        transform: translateY(100%);
        min-width: 117px;
        z-index: ${elevation.base.top};
        max-height: 200px;
        background-color: #fff;
        border-radius: 15px;
        -webkit-box-shadow: 0 14px 14px 3px rgba(16, 26, 49, 0.1);
        box-shadow: 0 14px 14px 3px rgba(16, 26, 49, 0.1);
        flex-direction:column;
        justify-content:space-between;
        .dropdown-list-item {
          padding: 5px;
          width:25%;
          display:inline-block;
          border-radius:5%;
          &:hover {
             background-color: ${(props: ThemeType) => 
               props.theme.colors.primaryLightThin};
          }
          &.selected {
            background-color: ${(props: ThemeType) =>
              props.theme.colors.primaryAccent};
            .sds-word {
              color: #fff;
            }
          }
        }
      }
      .dropdown-input {
        position: relative;
        background-color: ${(props: ThemeType) =>
          props.theme.colors.primaryLight};
        border-color: ${(props: ThemeType) => props.theme.colors.primaryLight};
        align-items: center;
        height: 55px;
        padding: 0px 15px;
        border-width: 1px;
        border-style: solid;
        border-radius: 2px;
        align-items: flex-start;
        justify-content: center;
        .dropdown-icon-container {
          position: absolute;
          right: 20px;
          width: 15px;
          height: 9px;
          top: 50%;
          transform: translateY(-50%);
        }
        &.selected {
          background-color: #fff;
          border-color: ${(props: ThemeType) => props.theme.colors.primaryAccent};
        }
      }
      }
}
 
`;
export default MonthPicker;

